import React, { useContext } from "react";
// import images
import logo from "../img/about/logo.png";
// import link
import { Link } from "react-router-dom";
// import motion
import { motion } from "framer-motion";
// import transition
import { transition1 } from "../transitions";
// import cursor context
import { CursorContext } from "../context/CursorContext";
import { ImArrowRight2 } from "react-icons/im";

const About = () => {
  const { mouseEnterHandler, mouseLeaveHandler } = useContext(CursorContext);
  return (
    <motion.section
      initial={{ opacity: 0, y: "100%" }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: "100%" }}
      transition={transition1}
      className="section  bg-gray-400"
    >
      <div
        onMouseEnter={mouseEnterHandler}
        onMouseLeave={mouseLeaveHandler}
        className="container mx-auto h-full relative"
      >
        {/* text & img wrapper */}
        <div className="flex flex-col lg:flex-row h-full items-center justify-center gap-x-24 text-center lg:text-left lg:pt-16">
          {/* image */}
          <div className="flex-1 max-h-50 lg:max-h-max order-2 lg:order-none overflow-hidden">
            <img src={logo} alt="" />
          </div>
          {/* text */}
          <motion.div
            initial={{ opacity: 0, y: "-80%" }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: "-80%" }}
            transition={transition1}
            className="flex-1 pt-36 pb-14 lg:pt-0 lg:w-auto z-10 flex flex-col justify-center text-justify items-center lg:items-start"
          >
            <h1 className="h1">About me</h1>
            <p className="mb-15 max-w-mb">
              Hello, I'm a passionate <b>Computer Science Engineering</b>{" "}
              enthusiast dedicated to improving my technical skills. I have a
              solid foundation in programming languages like{" "}
              <b>
                {" "}
                C++, Python, Java, HTML, CSS, ReactJS, SQL, MySql, GitHub and
                DSA.
              </b>{" "}
              I'm also experienced in design and 3D software, and actively
              contribute as a core team member of the Software Development Club
              at MVJCE. Eager to contribute to troubleshooting and real-time
              problem-solving while gaining hands-on experience in IT
              operations.
              <br />
            </p>
            <br />
            <Link to={"/projects"} className="btn">
              Projects &nbsp;
              <ImArrowRight2 />
            </Link>
          </motion.div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
